import { useParams } from "@tanstack/react-router";

import VStack from "@/components/Layout/VStack";

import { useSoftware } from "../_$id/-query";

import SoftwareBreadcrumb from "./SoftwareBreadcrumb";
import SoftwareHeader from "./SoftwareHeader";
import SoftwareHeaderTabs from "./SoftwareHeaderTabs";

export default function Header() {
  const { id } = useParams({ from: "/_staff/software/$id/_$id" });
  const { data } = useSoftware(id);

  return (
    <VStack className="gap-4 bg-background px-12 pt-4 shadow-xs">
      <SoftwareBreadcrumb name={data.info.name} />
      <SoftwareHeader software={data} />
      <SoftwareHeaderTabs id={id} />
    </VStack>
  );
}
